module.exports = __webpack_public_path__ + "static/media/s_11.55ad2de7.mp3";